export const ERROR_CARD = "ErrorCard";
export const ERROR_TITLE_ID = "ErrorTitleId";
export const ERROR_SUBTITLE_ID = "ErrorSubtitleId";
